import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2: rewritten for Project Explore (K-5), English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Invite Your Students",
    intro: "Add students to a class from Class Management.",
    steps: [
      "In your teacher dashboard, open Class Management.",
      "Choose Import Students.",
      "Type each student's first name, last name and email, or upload a CSV or Excel file.",
      "New students get an email with a link to the login page.",
    ],
    tip: "If your classes are in Google Classroom, choose Sync with Google Classroom in Class Management to bring in your classes and students.",
  },
  es: {
    title: "Cómo agregar a tus estudiantes",
    intro: "Agrega estudiantes a una clase desde Administrar clases.",
    steps: [
      "En tu panel de maestro, abre Administrar clases.",
      "Elige Importar estudiantes.",
      "Escribe el nombre, el apellido y el correo electrónico de cada estudiante, o sube un archivo CSV o de Excel.",
      "Los estudiantes nuevos reciben un correo electrónico con un enlace a la página para iniciar sesión.",
    ],
    tip: "Si tus clases están en Google Classroom, elige Sincronizar con Google Classroom en Administrar clases para traer tus clases y tus estudiantes.",
  },
};

export default function InviteYourStudents() {
  return <HelpArticle text={TEXT} />;
}
